import { Validators, FormBuilder, ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { HttpUtilService } from './../services/http-util.service';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material';
import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Inject, ViewChild, ElementRef, forwardRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { OutorgaService } from '../services/outorga.service';
import { CertificadoService } from './../services/certificado.service';

import { TrocarOutorgaComponent } from '../trocar-outorga/trocar-outorga.component';

import { tap } from 'rxjs/operators';
import DadosFingerprintModel from '../model/dados-fingerprint.model';
import { CadastraService } from './../services/cadastra.service';
import { MessageService } from './../services/message.service';
import { ModalTermoComponent } from './../modal-termo/modal-termo.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ConsultaMaquinaModel } from '../model/consulta-maquina.model';
import { ActivatedRoute } from '@angular/router'
import { Router } from '@angular/router';
import { GenericModalComponent } from '../generic-modal/generic-modal.component';
import { API_DOWNLOAD_KRYPTONITA } from '../app.api'
import Utils from '../utils/utils';
import { GlobalCripto } from './../global/global-constants';
import { AppComponent } from './../app.component'

@Component({
  selector: 'app-altera-estado-maquina',
  templateUrl: './altera-estado-maquina.component.html',
  styleUrls: ['./altera-estado-maquina.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AlteraEstadoMaquinaComponent),
      multi: true
    }
  ]
})
export class AlteraEstadoMaquinaComponent implements OnInit, ControlValueAccessor {

  @ViewChild('termo', { static: true }) myDiv: ElementRef;

  public inscricaoOutorgante: string;
  public tipoInscricaoOutorgante: string;
  dadosFingerprintModel: DadosFingerprintModel;

  cpfResponsavel;
  certificado;
  situacao: string= '';
  isEmpresaOutorgante;
  subscription: Subscription[] = [];
  lstEstados: Object[];
  status;
  conteudoTermo: any;
  chktermo: false;
  validaTermo;
  termoAceite;
  chaveResponsavelMaquina;
  chaveMaquina;
  inscricao;
  nomeMaquina = '';
  botaoContinuarClicado: boolean = false;
  terminoExecucao: boolean = false;
  onChange: any;

  dadosAlteraEstado = new ConsultaMaquinaModel();


  constructor(private fb: FormBuilder,
    private httpUtilService: HttpUtilService,
    private outorgaService: OutorgaService,
    private certificadoService: CertificadoService,
    @Inject(DOCUMENT) private document: Document,
    public dialogRef: MatDialogRef<TrocarOutorgaComponent>,
    private cadastraService: CadastraService,
    public messageService: MessageService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private appComponent: AppComponent
  ) { }

  ngOnInit() {
    this.lstEstados = this.Estados;
    this.outorgadoSubscribe();
    this.obterInscricao();
    this.cadastraService.ngOnInit();

    this.nomeMaquina = this.route.snapshot.params['nomeMaquina'];
    this.chaveMaquina = this.route.snapshot.params['chaveMaquina'];
    this.chaveResponsavelMaquina = this.route.snapshot.params['chaveResponsavelMaquina']
    this.situacao = this.route.snapshot.params['estadoMaquina']

    this.form.setValue({ ...this.form.value, nomeMaquina: this.nomeMaquina, situacao: this.situacao })

  }

  Estados: Object[] = [
    { id: '1', name: 'Ativo', value: '1', "checked": false },
    { id: '2', name: 'Bloqueado', value: '2', "checked": false }
  ];

  //Create a form
  form = this.fb.group({
    nomeMaquina: [this.nomeMaquina],
    estados: '',
    situacao: [this.situacao],
    chktermo: [false, Validators.pattern('true')],
    termo: ''
  });


  obterInscricao() {
    this.certificado = this.certificadoService.obterDadosCertificadoServlet();
    const { inscricao } = this.httpUtilService.obterDadosCertificado();
    this.inscricao = this.isEmpresaOutorgante ? this.inscricaoOutorgante : inscricao;
  }


  outorgadoSubscribe() {
    this.subscription.push(this.outorgaService.getOutorgado()
      .pipe(tap(v => v))
      .subscribe(response => {
        if (response && response[2]) {
          this.isEmpresaOutorgante = response[2];   
          this.tipoInscricaoOutorgante = response[0].toString().substring(0, 1);
          this.inscricaoOutorgante = Utils.formatarIncricao(response[0].toString().substring(1),  this.tipoInscricaoOutorgante);
          this.cpfResponsavel = Utils.formatarIncricao(response[2].cpf,'3');
        }
      }));
  }

  obterTermo(modal) {

    if (modal)
      return this.myDiv.nativeElement.innerHTML
    else
      return this.myDiv.nativeElement.innerText;
  }

  async gravar() {
    if (this.verificaInstalacaoCriptocnsKry()) {
      //limpa mensagem
      this.messageService.deleteAllMessages();
      this.botaoContinuarClicado = true;
      this.terminoExecucao = true;
      //assinatura do termo
      this.certificadoService.OnInit();
      const termoassinado = await this.certificadoService.assinarCriptoCns(this.certificado, this.obterTermo(false), false);
      
      if (termoassinado === null) {
        this.messageService.add("Alteração de Estado não foi realizado !.")
        this.terminoExecucao = false;
        this.botaoContinuarClicado = false;
      } else {
        let pem = termoassinado;
        this.dadosAlteraEstado.chaveResponsavel = this.chaveResponsavelMaquina
        this.dadosAlteraEstado.chaveMaquina = this.chaveMaquina;
        this.dadosAlteraEstado.termoAceite = pem;
        this.dadosAlteraEstado.codigoUsuarioResponsavel = "";
        this.dadosAlteraEstado.estadoMaquina = this.situacao == 'Ativo' ? '2' : '1';
        this.dadosAlteraEstado.termo = this.obterTermo(false);
        this.status = await this.cadastraService.atualizaEstadoMaquina(this.dadosAlteraEstado);
        console.log("situacao::: ", this.situacao);
        this.situacao = this.situacao === "Ativo" ? "Bloqueado" : "Ativo";
        console.log("situacao 2 ::: ", this.situacao);
        this.terminoExecucao = false;
        this.botaoContinuarClicado = true
      }
    }
  }

 async verificaInstalacaoCriptocnsKry() { 
    return await this.appComponent.verificaAPICriptoCNS();
  }
 
  openDialogKriptonita(mensagem: string, action: string, titulo: string, labelconfirmar: string, labelcancelar: string, help: boolean): string {
    const dialogRef = this.dialog.open(GenericModalComponent, { data: { mensagem, action, titulo, labelconfirmar, labelcancelar, help } });
    return mensagem;
  }

  cadastrado() {
    return this.status;
  }
  ngOnDestroy() {
    this.messageService.deleteAllMessages();
    this.subscription.forEach(s => s.unsubscribe());
  }

  openDialog() {
    const termo = this.obterTermo(true);
    this.dialog.open(ModalTermoComponent, {
      width: '750px',
      data: { termo }
    });
  }



  showOptions(event: MatCheckboxChange) {
    this.validaTermo = event.checked;

  }
  get estados() {
    return this.form.get('situacao');
  }

  onClose() {
    this.ngOnDestroy();
    this.router.navigate(['/consulta-maquina']);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void { }

  // Step 4: Define what should happen in this component, if something changes outside

  writeValue(obj: any) {
    this.situacao = obj;
  }

}
